// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a77f78e5","541":"96944a17","565":"d619f16c"}[chunkId] + ".chunk.js";
};